import { Fragment, type ReactNode } from "react";
import { useRetainedModalData } from "./hooks";
import Modal, { type ModalProps } from "./modal";

export interface ModalDataProps<T> extends Omit<
  ModalProps,
  "show" | "children"
> {
  data: T | null | undefined;
  children: (data: T) => ReactNode;
}

export default function ModalData<T>(props: Readonly<ModalDataProps<T>>) {
  const { data, children, onAfterClose, ...rest } = props;
  const retained = useRetainedModalData(data);

  function completeClose() {
    if (!retained.completeClose()) return;
    onAfterClose?.();
  }

  return (
    <Modal {...rest} show={retained.show} onAfterClose={completeClose}>
      {retained.data != null && (
        <Fragment key={retained.session}>{children(retained.data)}</Fragment>
      )}
    </Modal>
  );
}
